import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ecd358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "instructor-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "background-noise" }),
  /*#__PURE__*/_createElementVNode("div", { class: "background-skyline" })
], -1))
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "profile" }
const _hoisted_6 = {
  key: 0,
  class: "w-full h-full bg-chalk-dust-100"
}
const _hoisted_7 = { class: "clock" }
const _hoisted_8 = { class: "login" }
const _hoisted_9 = { class: "selected-course" }
const _hoisted_10 = {
  key: 0,
  class: "display-card"
}
const _hoisted_11 = {
  key: 1,
  class: "analytics"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold text-night-swamp-300" }, " Analytics Snapshot ", -1))
const _hoisted_13 = [
  _hoisted_12
]

import { useGlobalStore } from '../store/globalStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';
import { Class } from '@/models/Class';
import LoginButtonComponent from '@/components/LoginButtonComponent.vue';
import ClassLeaderBoard from '../components/instructorPage/ClassLeaderBoard.vue';
import ClassInformationOverview from '../components/instructorPage/ClassInformationOverview.vue';
import ClockTimerComponent from '@/components/studentPage/ClockTimerComponent.vue';
import ProfileDisplayComponent from '../components/instructorPage/ProfileDisplayComponent.vue';
import InstructorFeedbackForm from '../components/instructorPage/InstructorFeedbackForm.vue';
import ClassListWidget from '../components/instructorPage/ClassListWidget.vue';
import { Qualifier } from '@/models/Qualifier';
import Message from '@/models/Message';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructorPage',
  setup(__props) {

const { firebaseUser, currentUser, currentCourse, classes, students } =
  storeToRefs(useGlobalStore());
const resultMessage = ref('');

const store = useGlobalStore();
onBeforeMount(async () => {
  if (!currentUser || !currentUser.value) {
    return;
  }
  await store.fetchCourse(
    currentUser.value.organizationId,
    currentUser.value.courseId
  );
  await store.fetchClasses(currentUser.value.organizationId);
  onSelectClass(classes.value[0]);
});

const activeClass = ref<Class | null>(null);
const isValid = ref(false);

const studentsInActiveClass = computed(() => {
  if (!activeClass.value) {
    return [];
  }
  return students.value.filter((student) => {
    return student.classId === activeClass.value?.id;
  });
});

const onSelectClass = async (courseClass: Class) => {
  if (activeClass.value && activeClass.value.id === courseClass.id) {
    activeClass.value = null;
    return;
  }

  activeClass.value = courseClass;

  if (!currentUser || !currentUser.value || !courseClass.id) {
    return;
  }
  await store.fetchStudentUsers(
    currentUser.value.organizationId,
    currentUser.value.courseId,
    courseClass.id
  );
};

const setResultMessage = (message: string, valid: boolean) => {
  isValid.value = valid;
  resultMessage.value = message;
};

const onPublishMessage = async (message: string, qualifier: Qualifier) => {
  if (activeClass.value?.id && currentUser.value) {
    const bulletin = new Message();
    bulletin.author = 'Instructor';
    bulletin.authorId = currentUser.value.uid;
    bulletin.issueDate = new Date();
    bulletin.message = message;
    bulletin.qualifier = qualifier;
    bulletin.classId = activeClass.value.id;
    isValid.value = true;
    const result = await store.createMessage(bulletin);
    setResultMessage(result.resultMessage, !result.isError);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_unref(currentUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(ProfileDisplayComponent, {
                user: _unref(currentUser),
                classes: _unref(classes),
                selectedClass: activeClass.value
              }, null, 8, ["user", "classes", "selectedClass"]),
              _createVNode(ClassListWidget, {
                classes: _unref(classes),
                onItemClick: onSelectClass,
                selectedClass: activeClass.value
              }, null, 8, ["classes", "selectedClass"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(ClockTimerComponent)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(LoginButtonComponent, {
          isLoggedIn: _unref(currentUser) !== null,
          isEmailVerified: _unref(firebaseUser)?.emailVerified,
          currentUser: _unref(currentUser)
        }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(currentCourse) && activeClass.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(ClassInformationOverview, {
                course: _unref(currentCourse),
                _class: activeClass.value
              }, null, 8, ["course", "_class"]),
              _createVNode(ClassLeaderBoard, { studentList: _unref(studentsInActiveClass) }, null, 8, ["studentList"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(currentCourse) && activeClass.value)
        ? (_openBlock(), _createBlock(InstructorFeedbackForm, {
            key: 0,
            onPublish: onPublishMessage,
            class: "instructor-feedback"
          }, {
            "result-text": _withCtx(() => [
              _createElementVNode("p", {
                class: _normalizeClass(isValid.value ? 'success' : 'error')
              }, _toDisplayString(resultMessage.value), 3)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(currentCourse) && activeClass.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})